import React from 'react';
import customer from './img.json';
export function NotFound () {
  return <div className={'NotFound'} style={{
    backgroundImage: `url("data:image/svg+xml;base64,${customer.notFound}")`
  }}/>
}
